import { Component, OnInit } from '@angular/core';
import {AssetsService} from '../../../services/assets.service';
import {beforeUnloadEvent} from '../../../../core/utils/utils';
import {ConfigurationService} from '../../../../core/services/impl/configuration/configuration.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {PartnerService} from '../../../services/partner.service';
import {NotificationBase} from '../../../components/abstract/notification-base';

@Component({
  selector: 'app-connection-error-notification-web',
  templateUrl: './connection-error-notification-web.component.html',
  styleUrls: ['./connection-error-notification-web.component.scss']
})
export class ConnectionErrorNotificationWebComponent extends NotificationBase implements OnInit {

  constructor(private configuration: ConfigurationService,
              urlParamsService: UrlParamsService,
              partnerService: PartnerService,
              private assetsService: AssetsService) {
    super(urlParamsService, partnerService);
  }

  ngOnInit() {
  }

  refreshApp() {
    if (!this.anchorButton) {
      window.removeEventListener('beforeunload', beforeUnloadEvent);
      window.location.reload();
      window.addEventListener('beforeunload', beforeUnloadEvent);
    }
  }

  get logoUrl(): string {
    return this.configuration.uiConfig.headerConfig.logo.url;
  }

  get informationImage(): string {
    return this.assetsService.informationDialogImageSrc;
  }
}
